<template>
	<div class="shopCar layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				购物车
			</div>
		</div>
		<table class="layui-table align_center" style="width:90%;margin:50px 5%;">
			<colgroup>
				<col width="150">
				<col width="200">
				<col>
			</colgroup>
			<thead>
				<tr>
					<th class="align_center"></th>
					<th class="align_center">序号</th>
					<th class="align_center">规格</th>
					<th class="align_center">数量</th>
					<th class="align_center">交付类型</th>
					<th class="align_center">价格</th>
					<th class="align_center">操作</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item,i) in datas" :key="i">
					<td @click="checkedIndex(i)" class="pointer">
						<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 zt_txt_color"></i>
					</td>
					<td>{{i+1}}</td>
					<td>{{item.attr_id_text}}</td>
					<td>{{item.buy_num}}</td>
					<td :class="item.is_fast == 58 ? 'fast' : ''">{{item.is_fast_text}}</td>
					<td>{{item.price}}</td>
					<td>
						<button class="layui-btn layui-btn-normal layui-btn-sm" @click="goodsDetail(item.id)">详情</button>
						<button class="layui-btn layui-btn-danger layui-btn-sm" @click="delShopCar(item.id)">移出购物车</button>
					</td>
				</tr>
				<tr v-if="datas.length == 0">
					<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="7">暂无数据</td>
				</tr>
			</tbody>
		</table>
		<div class="f_row al_itm px16" style="margin:30px 5%;">
			<div @click="checkedAll" class="pointer">
				<i v-show="checkAll" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
				<i v-show="!checkAll" class="layui-icon-circle layui-icon px20 zt_txt_color"></i>
			</div>
			<span>&nbsp;&nbsp;已选 {{nums}} 个，合计</span>
			<span class="mon_color">&nbsp;￥{{money}}</span>
		</div>
		<div class="layui-btn-container" style="margin:30px 5%;">
			<button @click="onSettle" type="button" class="layui-btn zt_color">立即结算</button>
			<button @click="goCreatOrder" type="button" class="layui-btn" style="margin-left:20px;background:#1AAD19;">继续下单</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'shopCar',
		data() {
			return {
				nums: 0,
				money: 0,
				dscModel: false,
				checkAll: false,
				datas: []
			}
		},
		created() {

		},
		mounted() {
			let _this = this;
			layui.use(['layer'], () => {
				_this.getData();
			});
		},
		methods: {
			getData() {
				api.getShopCarList({
					token: this.getCookie('token')
				}).then((res) => {
					if(res.code == 1) {
						for(let i = 0; i < res.data.list.length; i++) {
							res.data.list[i].checked = false;
						}
						this.datas = res.data.list;
					} else {
						this.datas = [];
					}
				})
			},
			goodsDetail(id) { //查看购物车商品
				this.$router.push({
					path: '/goods',
					query: {
						id: id
					}
				})
			},
			delShopCar(id) { //删除购物车
				let _this = this;
				layui.use(['layer'], () => {
					let layer = layui.layer;
					layer.open({
						type: 0,
						content: '是否需确认删除该商品？',
						btn: ['确认', '取消'],
						btnAlign: 'c',
						resize: false,
						closeBtn: 0,
						skin: 'demo-class',
						yes: function(index, layero) {
							layer.closeAll();
							api.delShopCar({
								token: _this.getCookie('token'),
								id: id
							}).then((res) => {
								if(res.code == 1) {
									_this.getData();
								} else {
									_this.layers.msg(res.msg, {
										icon: 2,
										anim: 6
									});
								}
							})
						},
						btn2: function(index, layero) {
							layer.closeAll();
						}
					});
				});
			},
			goCreatOrder(e) { //继续下单
				this.$router.push({
					path: '/creatOrder'
				})
			},
			onSettle() { //结算
				let id = [];
				let is_fast = 0;
				let len = 0;
				let is_handle_demand = false;
				for(let i = 0; i < this.datas.length; i++) {
					if(this.datas[i].checked == true) {
						if(this.datas[i].handle_demand == 2){
							is_handle_demand = true;							
						}
						len += 1;
						if(len > 1 && is_handle_demand) {
							layer.msg('需要确认PDF的订单不能合并结算', {
								icon: 2,
								anim: 6
							})
							return false;
						}
						id.push(this.datas[i].id);
						if(this.datas[i].is_fast == 58 && !is_fast) {
							is_fast = 58;
						}else if(this.datas[i].is_fast == 57 && !is_fast){
							is_fast = 57;
						}
						
						if(is_fast == 58 && this.datas[i].is_fast != 58) {
							layer.msg('加急件和普通件不能同时结算', {
								icon: 2,
								anim: 6
							})
							return false;
						} else if(is_fast == 57 && this.datas[i].is_fast != 57) {
							layer.msg('加急件和普通件不能同时结算', {
								icon: 2,
								anim: 6
							})
							return false;
						}
					}
				}
				
				
				if(id.length == 0) {
					layer.msg('请选择订单', {
						icon: 2,
						anim: 6
					})
					return false;
				}
				this.$router.push({
					path: '/payment',
					query: {
						id: id.join(',')
					}
				})
			},
			total() {
				let money = 0;
				let nums = 0;
				for(let i = 0; i < this.datas.length; i++) {
					if(this.datas[i].checked == true) {
						money += parseFloat(this.datas[i].price);
						nums += 1;
					}
				}
				this.money = parseFloat(money).toFixed(2);
				this.nums = nums;
			},
			checkedIndex(i) {
				this.datas[i].checked = !this.datas[i].checked;
				let len = 0;
				this.datas.forEach((item) => {
					if(item.checked) {
						len += 1;
					}
				});
				if(len == this.datas.length) {
					this.checkAll = true;
				} else {
					this.checkAll = false;
				}
				this.total();
			},
			checkedAll() {
				this.checkAll = !this.checkAll;
				for(let i = 0; i < this.datas.length; i++) {
					this.datas[i].checked = this.checkAll;
				}
				this.total();
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.shopCar {
		font-family: SourceHanSansSC;
	}
	
	.fast {
		color: #FF0000;
	}
</style>


// WEBPACK FOOTER //
// src/components/shopCar.vue